import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import moment from 'moment';
import { CrudStatusType } from 'src/app/enum/crud-status-type';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ResellerService } from 'src/app/services/reseller.service';
import swal from 'sweetalert2';
import * as _ from "lodash";
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-manage-reseller-sales',
  templateUrl: './manage-reseller-sales.component.html',
  styleUrls: ['./manage-reseller-sales.component.scss']
})
export class ManageResellerSalesComponent implements OnInit {

  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "resellerName", "resellerCode", "resellerSalesName", "resellerSalesCode", "presentInPrepaid", "action"
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  roleTypeEnum = RoleType;
  sessionDataString: any;
  selectedIndex: number;

  constructor(
    private navigationService: NavigationService,
    private excelService: ExcelService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private sessionService: UserSessionService,
    private ResellerService: ResellerService,
  ) {

  }

  ngOnInit() {
    this.getTableData('');
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
  }

  getTableData(data) {
    if (data) {
      data = { searchText: data }
    }
    this.ResellerService.getResellerSalesList(data).subscribe((result) => {
      debugger
      console.log(result);
      this.data = result;
      this.dataExcel = result;
      this.data = _.orderBy(this.data, ["priority"]);
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
  }

  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort.active = '';
    this.dataSource.sort.direction = '';
    this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
    this.getTableData('');
  }

  goToManageResellerSalesAdd(id) {
    this.navigationService.goToManageResellerSalesForm(id, 0); // add
  }

  goToManageResellerSalesEdit(id) {
    this.navigationService.goToManageResellerSalesForm(id, 1); // edit
  }

  goToManageResellerSalesView(id) {
    this.navigationService.goToManageResellerSalesForm(id, 2); // view
  }

  deleteUser(user) {
    const txt = 'Are you sure want to Deactivate ' + user.resellerSalesName + ' ?';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.ResellerService.deleteResellerSalesById(user.id).subscribe((result: any) => {
          if (result != null && result.statusType == 0) {
            this.toastr.showSuccess("Deactivated Successfully");
          } else {
            this.toastr.showError("Failed to Deactivate");
          }
          this.getTableData('');
        });
      }
    });
  }

  delete(user) {
    user.id = isNaN(user.id) ? 0 : user.id;
    if (user.id !== 0) {
      this.ResellerService.IsResellerSalesDeleteAllowed(user.resellerSalesCode).subscribe(res => {
        if (!res) {
          this.deleteUser(user);
        } else {
          this.toastr.showError("Requested information is in use.");
        }
      });
    }
  }

  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        'Reseller Name',
        'Reseller Code',
        'Reseller Sales Name',
        'Reseller Sales Code',
        'Present In Prepaid'
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          sno: ++index,
          "resellerName": a.resellerName,
          "resellerCode": a.resellerCode,
          "resellerSalesName": a.resellerSalesName,
          "resellerSalesCode": a.resellerSalesCode,
          "presentInPrepaid": a.presentInPrepaid ? "Yes" : "No"

        });
      });
      this.excelService.exportAsExcelFile(excelList, "Manage_Reseller_Sales_Report_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index
  }


}
